function BulletSeparator() {
  return <span>&nbsp;&bull;&nbsp;</span>;
}

export default BulletSeparator;
